import {btn, Button, column, comp, EntityID, h3, hr, menu, mstbar, radio, router, searchbtn, tbar} from "@intermesh/goui";
import {formbooktable} from "./FormBookTable.js";
import {FormBookWindow} from "./FormBookWindow";
import {FormTable, formtable} from "./FormTable";
import {FormWindow} from "./FormWindow";
import {FormDetail} from "./FormDetail";
import {filterpanel, jmapds, MainThreeColumnPanel} from "@intermesh/groupoffice-core";

import {t} from "./Translate";

export class MainPanel extends MainThreeColumnPanel {
	private formTable?: FormTable;

	/**
	 * Used to track if module has been initialized. Then filter changes will be updating the data.
	 * @private
	 */
	private loaded: boolean = false;

	protected east!: FormDetail;
	private addBookBtn: Button|undefined;

	constructor() {
		super("forms");
	}

	createWest() {

		return comp({
			width: 260,
			itemId: "west",
			stateId: "forms-west"
		},
			tbar({
				cls: "border-bottom"
				},
				h3(t("Books")),
				'->',
				btn({
					title: "Add",
					icon: "add",
					handler: () => {
						const d = new FormBookWindow();
						d.show();
					}
				}),
				this.hideWestButton(),
				this.closeWestButton()
			),

			formbooktable({
				cls: "no-row-lines",
				headers: false,
				columns: [
					// checkboxselectcolumn(),
					column({
						id: "name"
					}),
					column({
							width: 48,
							id: "btn",
							// headerRenderer: (col: TableColumn, headerEl: HTMLTableCellElement, table: Table) => {
							// 	headerEl.style.position = "sticky";
							// 	headerEl.style.right = "0";
							// 	return "";
							// },
							renderer: (columnValue: any, record, td, table, rowIndex) => {
								// td.style.position = "sticky";
								// td.style.right = "0";



								return btn({
									icon: "more_vert",
									menu: menu({},
										btn({
											icon: "edit",
											text: t("Edit"),
											handler: async (btn) => {
												const book = table.store.get(rowIndex)!;
												const d = new FormBookWindow();
												await d.load(book.id);
												d.show();
											}
										}),
										hr(),
										btn({
											icon: "delete",
											text: t("Delete"),
											handler: async (btn) => {
												const book = table.store.get(rowIndex)!;
												jmapds("FormBook").confirmDestroy([book.id]);
											}
										})

										)
								})
							}
						}),

				],
				listeners: {
					render: async ({target}) => {
						await target.store.load();
						target.rowSelection!.selectIndex(0);

						this.loaded = true;
						this.formTable?.store.setFilter("archive", {archived: false});
						void this.formTable!.store.load();
					}
				},
				rowSelectionConfig: {
					multiSelect: false,
					listeners: {

						selectionchange: ({selected}) => {

							const bookIds = selected.map((r) => r.id);
							this.formTable!.store.setFilter("book", {bookId: bookIds[0]})
							this.addBookBtn!.disabled = false;
							if(this.loaded) {
								void this.formTable!.store.load();
							}

						}
					}
				}
			}),
			// filterpanel({
			// 	entityName: "Form",
			// 	store: this.formTable!.store
			// }),

			tbar({}, h3(t("Status"))),

			radio({
				type: "list",
				listeners:{
					change: ({newValue}) => {

						this.formTable?.store.setFilter("archive",  newValue == "" ? undefined : {archived: newValue === "1"});
						void this.formTable!.store.load();
					}
				},
				value: "0",
				options: [
					{text: t("All"), value: "", icon: "star"},
					{text: t("Active"), value: "0", icon: "today"},
					{text: t("Archive"), value: "1", icon: "archive"},
				]
			})
		)
	}


	createCenter() {

		this.formTable = formtable({
			listeners: {
				rowdblclick:({target, storeIndex}) => {
					const d = new FormWindow();
					d.show();
					void d.load(target.store.get(storeIndex)!.id);
				},

				delete: async () => {
					const ids = this.formTable!.rowSelection!.getSelected().map(r => r.id);
					await jmapds("Form")
						.confirmDestroy(ids);
				}
			},

			rowSelectionConfig: {
				listeners: {
					selectionchange: ({selected}) => {
						if(selected.length) {
							router.goto("forms/" + selected[0]!.id);
						}
					}
				}
			}
		});

		return comp({
			flex: 1,
			cls: 'vbox active' //for mobile view this is active
		},
			tbar({
					cls: "border-bottom table-aligned"
				},

				this.showWestButton(),
				this.openWestButton(),

				'->',

				searchbtn({
					listeners: {
						input: ({text}) => {
							this.formTable!.store.setFilter("search", {text: text})
						}
					}
				}),

				this.addBookBtn = btn({
					title: "Add",
					text: t("Add"),
					cls: "filled primary",
					icon: "add",
					disabled: true,
					handler: () => {
						const d = new FormWindow();
						d.form.value = {
							bookId: this.formTable!.store.getFilter("book").bookId
						};
						d.show();
					}
				}),

				mstbar({table: this.formTable!},
					"->",
					btn({
						icon: "delete",
						handler: async (btn) => {

							const ids = this.formTable!.rowSelection!.getSelected().map(r => r.id);

							const result = await jmapds("Form")
								.confirmDestroy(ids);

							if(result != false) {
								btn.parent!.hide();
							}

						}
					})
				),
			),

			comp({flex: 1, cls: "scroll main"},
				this.formTable
			)
		)
	}

	protected createEast() {
		const detail = new FormDetail();
		detail.width = 700;
		detail.itemId = "detail";
		detail.stateId = "forms-detail";

		detail.toolbar.items.insert(0,this.hideEastButton());
		return detail;
	}

	setFormId(FormId:EntityID) {
		void this.east.load(FormId);
		this.activatePanel(this.east);
	}
}

